class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.wrapper = this.notification ? this.notification.closest('.cart-notification-wrapper') : null;
    this.content = this.notification ? this.notification.querySelector('.cart-notification__content') : null;
    this.headingText = this.notification ? this.notification.querySelector('.cart-notification__heading-text') : null;
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.notification.addEventListener('click', this.handleClick.bind(this));
    this.notification.addEventListener('change', this.handleChange.bind(this));

  }

  updateFooterHeight() {
    if (!this.notification) return;
    const footer = this.notification.querySelector('.cart-notification__links');
    if (!footer) return;
    const height = footer.offsetHeight;
    if (height > 0) {
      this.notification.style.setProperty('--cart-drawer-footer-height', `${height}px`);
    }
  }

  isDrawerEnabled() {
    if (this.dataset.cartDrawerEnabled === undefined) return true;
    return this.dataset.cartDrawerEnabled === 'true';
  }

  open() {
    if (!this.isDrawerEnabled()) return;
    if (this.content) {
      this.content.scrollTop = 0;
    } else if (this.notification) {
      this.notification.scrollTop = 0;
    }
    this.notification.classList.add('animate', 'active');
    if (this.wrapper) this.wrapper.classList.add('cart-notification-wrapper--active');
    document.body.classList.add('cart-drawer-open');
    requestAnimationFrame(() => this.updateFooterHeight());

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  updateHeading(isAddToCart) {
    if (!this.headingText) return;
    const addedText = this.headingText.dataset.addedText;
    const cartText = this.headingText.dataset.cartText;
    if (isAddToCart) {
      if (this.notification) this.notification.classList.remove('cart-notification--cart-view');
      this.headingText.textContent = addedText || this.headingText.textContent;
      return;
    }
    if (this.notification) this.notification.classList.add('cart-notification--cart-view');
    if (cartText) {
      this.headingText.textContent = cartText;
    }
  }

  close() {
    this.notification.classList.remove('active');
    if (this.wrapper) this.wrapper.classList.remove('cart-notification-wrapper--active');
    document.body.classList.remove('cart-drawer-open');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.updateSections(parsedState);
      this.updateHeading(true);

      if (this.header) this.header.reveal();
      if (this.isDrawerEnabled()) this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: '.cart-notification-products',
      },
      {
        id: 'cart-notification-footer',
        selector: '.cart-notification__links',
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateSections(parsedState) {
    this.renderSections(parsedState.sections);
  }

  renderSections(sections) {
    if (!sections) return;
    this.getSectionsToRender().forEach((section => {
      const container = document.getElementById(section.id);
      if (!container || !sections[section.id]) return;
      container.innerHTML = this.getSectionInnerHTML(sections[section.id], section.selector);
    }));
    requestAnimationFrame(() => this.updateFooterHeight());
  }

  openWithCart() {
    if (!this.isDrawerEnabled()) return;
    const sectionIds = this.getSectionsToRender().map((section) => section.id).join(',');
    const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    this.updateHeading(false);
    fetch(`${cartUrl}?sections=${sectionIds}`)
      .then((response) => response.json())
      .then((sections) => {
        this.renderSections(sections);
        this.open();
      })
      .catch((error) => {
        console.error(error);
        this.open();
      });
  }

  handleClick(event) {
    const qtyButton = event.target.closest('[data-qty-button]');
    if (qtyButton) {
      event.preventDefault();
      const line = qtyButton.dataset.line;
      const direction = qtyButton.dataset.qtyButton;
      const input = this.notification.querySelector(`[data-line-input="${line}"]`);
      if (!input) return;
      const current = parseInt(input.value, 10) || 0;
      const nextValue = direction === 'plus' ? current + 1 : current - 1;
      if (nextValue < 0) return;
      input.value = nextValue;
      this.updateQuantity(line, nextValue);
      return;
    }

    const removeButton = event.target.closest('[data-remove-line]');
    if (removeButton) {
      event.preventDefault();
      const line = removeButton.dataset.removeLine;
      this.updateQuantity(line, 0);
      return;
    }

    const upsellButton = event.target.closest('[data-swap-line][data-swap-variant]');
    if (upsellButton) {
      event.preventDefault();
      const swapQuantity = parseInt(upsellButton.dataset.swapQuantity, 10);
      const quantity = Number.isNaN(swapQuantity) || swapQuantity < 1 ? 1 : swapQuantity;
      this.swapCartItem(upsellButton.dataset.swapLine, upsellButton.dataset.swapVariant, upsellButton, quantity);
    }
  }

  handleChange(event) {
    const input = event.target.closest('[data-line-input]');
    if (!input) return;
    const line = input.dataset.lineInput;
    const value = parseInt(input.value, 10);
    if (Number.isNaN(value)) return;
    this.updateQuantity(line, value);
  }

  updateQuantity(line, quantity) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.updateSections(parsedState);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  swapCartItem(lineItemKey, newVariantId, btnElement, quantity = 1) {
    if (btnElement) {
      btnElement.classList.add('is-loading');
      btnElement.disabled = true;
      if (!btnElement.dataset.originalText) {
        btnElement.dataset.originalText = btnElement.textContent;
      }
      btnElement.textContent = 'Updating...';
    }

    const formData = {
      items: [
        {
          id: newVariantId,
          quantity,
          properties: { _Upsell: 'Cart Drawer Button' }
        }
      ]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
      .then(() => {
        return fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: lineItemKey,
            quantity: 0,
            sections: this.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
          })
        });
      })
      .then((response) => response.json())
      .then((state) => {
        this.updateSections(state);
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        if (btnElement) {
          btnElement.classList.remove('is-loading');
          btnElement.disabled = false;
          btnElement.textContent = btnElement.dataset.originalText || btnElement.textContent;
        }
      });
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target &&
      target.closest &&
      target.closest('[id*="klaviyo"], [class*="klaviyo"], [data-klaviyo], .klaviyo-form, .klaviyo-bis, .klaviyo-bis-trigger, .klaviyo-teaser')
    ) {
      return;
    }
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

document.addEventListener('click', (event) => {
  const cartIcon = event.target.closest('#cart-icon-bubble');
  if (!cartIcon) return;
  const drawer = document.querySelector('cart-notification');
  if (!drawer || typeof drawer.open !== 'function') return;
  if (drawer.notification && drawer.notification.classList.contains('active')) return;
  if (typeof drawer.isDrawerEnabled === 'function' && !drawer.isDrawerEnabled()) return;
  event.preventDefault();
  if (typeof drawer.openWithCart === 'function') {
    drawer.openWithCart();
  } else {
    drawer.open();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('cart-notification');
  if (!drawer || typeof drawer.openWithCart !== 'function') return;
  if (typeof drawer.isDrawerEnabled === 'function' && !drawer.isDrawerEnabled()) return;
});
